export const cloudfrontUrlToFile = async (url, callback) => {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "*/*",
      },
    });

    if (!response.ok) {
      callback(new Error(`HTTP error! status: ${response.status}`), null);
      return;
    }

    const blob = await response.blob();
    const parts = url.split("/");
    const fileName = parts[parts.length - 1];

    const file = new File([blob], fileName, { type: blob.type });
    const reader = new FileReader();

    reader.onloadend = () => {
      const dataUrl = reader.result;
      callback(null, { file, dataUrl });
    };

    reader.onerror = (error) => {
      callback(error, null);
    };

    reader.readAsDataURL(blob);
  } catch (error) {
    callback(error, null);
  }
};
